import React, { useState, useEffect, useContext } from "react";
import AddDivisionForm from "./AddDivision";
import EditDivisionForm from "./EditDivision";
import axios from "axios";
import { toast } from "react-toastify";
import { AuthContext } from "../../Context/AuthContext";
import { logActivity } from "../../utils/LogActivity";
import Preloader from "../../shared/PreLoaders";
import { Authorization } from "../../Context/Authorization";

const thStyle = { padding: "10px 12px", fontSize: 12, fontWeight: 700, color: "#2D3748", background: "#F7FAFC", border: "1px solid #E2E8F0", textAlign: "left" };
const tdStyle = { padding: "9px 12px", fontSize: 12, color: "#4A5568", border: "1px solid #E2E8F0" };

const Division = () => {
  const [division, setDivision] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [currentDivision, setCurrentDivision] = useState(null);
  const { permissions, userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    const fetchDivision = async () => {
      const config = Authorization();
      try {
        const response = await axios.get(`${Api}/api/divisions`, config);
        const data = response.data;
        if (Array.isArray(data)) setDivision(data);
      } catch (err) {
        console.error("Error fetching data", err);
      }
      setLoading(false);
      await logActivity(userId, "Viewed Division", "Division Page", Api);
    };
    fetchDivision();
  }, [Api]);

  const handleDeleteDivision = async (id) => {
    if (!window.confirm("Are you sure you want to delete this Division?")) return;
    try {
      const config = Authorization();
      await axios.delete(`${Api}/api/divisions/${id}`, config);
      setDivision(division.filter((d) => d._id !== id));
      toast.success("Deleted Successfully");
    } catch (err) {
      console.error("Error deleting Division", err);
      toast.error("Failed to delete the division.");
    }
  };

  const handleAddDivision = (newDivision) => setDivision([...division, newDivision]);

  return (
    <div>
      {loading && <Preloader loading={loading} />}

      {/* ── Page Header ── */}
      <div style={{ marginBottom: 20 }}>
        <h4 style={{ margin: 0, fontWeight: 700, color: "#1A202C", fontSize: 18 }}>Division</h4>
        <div style={{ fontSize: 12, color: "#718096", marginTop: 3 }}>
          <span style={{ color: "#A0AEC0" }}>VFC</span>
          <span style={{ margin: "0 6px", color: "#CBD5E0" }}>›</span>
          <span style={{ color: "#2E7D32", fontWeight: 600 }}>Division</span>
        </div>
      </div>

      {/* ── Table Card ── */}
      <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", boxShadow: "0 1px 4px rgba(0,0,0,0.07)", overflow: "hidden" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)" }}>
          <span style={{ width: 30, height: 30, background: "rgba(255,255,255,0.15)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 15 }}>
            <i className="mdi mdi-view-dashboard-outline" />
          </span>
          <span style={{ fontSize: 13, fontWeight: 700, color: "#fff", flex: 1 }}>Division List</span>
          <span style={{ padding: "3px 10px", background: "rgba(255,255,255,0.2)", borderRadius: 20, fontSize: 11, color: "#fff", fontWeight: 600 }}>
            {division.length} Records
          </span>
          {permissions.includes("AddDivision") && (
            <button onClick={() => setShowPopup(true)}
              style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "7px 14px", background: "rgba(255,255,255,0.2)", color: "#fff", border: "1px solid rgba(255,255,255,0.4)", borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
              <i className="mdi mdi-plus" /> Create New
            </button>
          )}
        </div>

        <div style={{ padding: 16, overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={thStyle}>#</th>
                <th style={thStyle}>Division Name</th>
                <th style={thStyle}>Division Code</th>
                <th style={thStyle}>Circle Name</th>
                {permissions.includes("EditDivision") && permissions.includes("DeleteDivision") && (
                  <th style={thStyle}>Actions</th>
                )}
              </tr>
            </thead>
            <tbody>
              {division.length === 0 ? (
                <tr>
                  <td colSpan={5} style={{ ...tdStyle, textAlign: "center", color: "#A0AEC0", padding: "40px" }}>No division records found.</td>
                </tr>
              ) : (
                division.map((item, index) => (
                  <tr key={item._id} style={{ background: index % 2 === 0 ? "#fff" : "#F7FAFC" }}>
                    <td style={tdStyle}>{index + 1}</td>
                    <td style={{ ...tdStyle, fontWeight: 600, color: "#2D3748" }}>{item.divisionName}</td>
                    <td style={tdStyle}>{item.divisionCode}</td>
                    <td style={tdStyle}>{item.circleId?.circleName || "-"}</td>
                    {permissions.includes("EditDivision") && permissions.includes("DeleteDivision") && (
                      <td style={tdStyle}>
                        <i className="mdi mdi-pen" style={{ fontSize: "1.4rem", cursor: "pointer", marginRight: 8, color: "#2E7D32" }}
                          onClick={() => { setCurrentDivision(item); setShowEditPopup(true); }} />
                        <i className="mdi mdi-delete" style={{ fontSize: "1.4rem", cursor: "pointer", color: "#E53E3E" }}
                          onClick={() => handleDeleteDivision(item._id)} />
                      </td>
                    )}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {showPopup && <AddDivisionForm onClose={() => setShowPopup(false)} onAddDivision={handleAddDivision} />}
      {showEditPopup && currentDivision && <EditDivisionForm division={currentDivision} onClose={() => { setShowEditPopup(false); setCurrentDivision(null); }} />}
    </div>
  );
};

export default Division;
